<template>
  <footer class="footer global-foot">
    <div class="container">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-lg-12 text-center">
          <div class="copyright text-center text-light">
            <span
              >RhomTrip {{ systemInfo.name }}. v.{{
                systemInfo.release.version
              }}
              Enterprise Edition. © {{ systemInfo.year }}. RhomTrip OÜ™. All
              Rights Reserved.</span
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "globalFooter",
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["setsystemInfo"])
  },
  computed: {
    ...mapGetters(["systemInfo"])
  }
};
</script>
<style></style>
